
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M9.99998 3H14C14.55 3 15 2.55 15 2C15 1.45 14.55 1 14 1H9.99998C9.44998 1 8.99998 1.45 8.99998 2C8.99998 2.55 9.44998 3 9.99998 3ZM12 8C11.49 8 11.08 8.39 11.02 8.89L13 10.86V9C13 8.45 12.55 8 12 8ZM12 6C15.87 6 19 9.13 19 13C19 14.12 18.73 15.18 18.26 16.12L19.73 17.59C20.53 16.25 21 14.68 21 13C21 10.88 20.26 8.93 19.03 7.39L19.78 6.64C20.16 6.26 20.17 5.63 19.78 5.24L19.77 5.23C19.38 4.84 18.76 4.85 18.37 5.23L17.62 5.98C16.07 4.74 14.12 4 12 4C10.34 4 8.77998 4.48 7.42998 5.29L8.87998 6.74C9.81998 6.27 10.88 6 12 6ZM20.19 20.88L3.86998 4.56C3.47998 4.17 2.84998 4.17 2.45998 4.56C2.06998 4.95 2.06998 5.58 2.45998 5.97L4.52998 8.04C3.60998 9.42 3.04998 11.03 2.99998 12.76C2.86998 17.84 6.93998 22 12 22C13.84 22 15.55 21.45 16.98 20.5L18.77 22.29C19.16 22.68 19.79 22.68 20.18 22.29C20.58 21.9 20.58 21.27 20.19 20.88ZM12 20C8.12998 20 4.99998 16.87 4.99998 13C4.99998 11.71 5.34998 10.51 5.95998 9.48L15.53 19.05C14.49 19.65 13.29 20 12 20Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-timer-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconTimerOff

    ```js
    <b-new-b-icon-timer-off />
    ```
</docs>


